import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const FormItemContainer = styled.div`
	padding: var(--padding-2);
	display: flex;
	flex-direction: ${(props) => (props.direction ? props.direction : 'column')};
	gap: 0.75rem;

	${(props) =>
		props.direction === 'row' || props.direction === 'row-reverse' ? 'align-items: center; gap: 2rem;' : ''}
	${(props) => (props.direction === 'row-reverse' ? 'justify-content: flex-end;' : '')}

	.formitem-row,
	.formitem-row-reverse {
		width: unset;
		flex: unset;
	}

	.formitem-row-reverse.form-item-content {
		flex: 0 0 auto;
	}

	> .form-item-content {
		display: flex;
		flex-direction: column;
		flex: 1 1 auto;

		> .skeleton {
			height: 4.5rem;
			min-height: 4.5rem;

			body[dir='rtl'] & {
				height: 5.5rem;
				min-height: 5.5rem;
			}
		}
	}

	@media ${Breakpoints.mobile} {
		padding: var(--padding-3) var(--padding-2);
	}
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Required = styled.span`
	color: var(--red);
	margin-left: 0.25rem;

	body[dir='rtl'] & {
		margin-left: unset;
		margin-right: 0.25rem;
	}
`;
